import {
  createReducer,
  createNamespacer
} from '../../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';

const initialState = {
  addProject: {
    code: {
      value: '',
      error: '',
      showError: ''
    },
    projectName: {
      value: '',
      error: '',
      showError: ''
    },
    street: {
      value: '',
      error: '',
      showError: ''
    },
    projectState: {
      value: '',
      error: '',
      showError: ''
    },
    city: {
      value: '',
      error: '',
      showError: ''
    },
    zipcode: {
      value: '',
      error: '',
      showError: ''
    },
    owner: {
      value: [],
      error: '',
      showError: ''
    },
    foremen: {
      value: [],
      error: '',
      showError: ''
    },
    lotSize: {
      value: '',
      error: '',
      showError: ''
    },
  }
};

const addProject = createNamespacer('ADD_PROJECT');

export const addProjectReducer = createReducer(initialState.addProject, {
  [addProject('SET_ERROR')]: (state, action) => {
    return {
      ...state,
      error: action.payload.value
    };
  },
  [addProject('SET_PROJECT_CODE')]: (state, action) => {
    return {
      ...state,
      code: {
        ...state.code,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_PROJECT_NAME')]: (state, action) => {
    return {
      ...state,
      projectName: {
        ...state.projectName,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_STREET')]: (state, action) => {
    return {
      ...state,
      street: {
        ...state.street,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_CITY')]: (state, action) => {
    return {
      ...state,
      city: {
        ...state.city,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_STATE')]: (state, action) => {
    return {
      ...state,
      projectState: {
        ...state.projectState,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_ZIPCODE')]: (state, action) => {
    return {
      ...state,
      zipcode: {
        ...state.zipcode,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_OWNER')]: (state, action) => {
    return {
      ...state,
      owner: {
        ...state.owner,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_FOREMEN')]: (state, action) => {
    return {
      ...state,
      foremen: {
        ...state.foremen,
        value: action.payload.value
      }
    };
  },
  [addProject('SET_FIELD_ERRORS')]: (state, action) => {
    let errors = action.payload.value;

    const loadedFields = _fromPairs(
      Object.entries(errors).map(error => {
        const [key, value] = error;
        return [
          key,
          {
            ...state[key],
            error: value
          }
        ];
      })
    );

    return {
      ...state,
      ...loadedFields
    };
  },
  [addProject('STORE_EXAMINATION_PERCENTAGE')]: (state, action) => {
    return {
      ...state,
      lotSize: {
        ...state.lotSize,
        value: action.payload.value
      }
    };
  },
  [addProject('CLEAR_FORM')]: (state, action) => {
    action.payload.owner.forEach(value => {
      return (value.deleted = true);
    });

    action.payload.foremen.forEach(value => {
      return (value.deleted = true);
    });

    action.payload.crewForemen.forEach(value => {
      return (value.deleted = true);
    });

    return {
      ...initialState.addProject
    };
  }
});
